import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";

import { Metadata } from "../../../models/metadata";
import { MetadataType } from "../../../enums/metadatatype";

@Component({
    selector: "managemetadata",
    templateUrl: "./managemetadata.component.html",
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class ManageMetadataComponent implements OnInit  {
    metadataList: Metadata[];
    metadataType: any = MetadataType;
    showDisabled: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router) {
    }

    ngOnInit(): void {
        this.metadataList = this.activatedRoute.snapshot.data["metadataList"];
    }

    createMetadata(): void {
        this.router.navigate(["/metadata"]);
    }

    editMetadata(metadata: Metadata): void {
        this.router.navigate([`/metadata/${metadata.id}`]);
    }

    toggleDisabled(): void {
        this.showDisabled = !this.showDisabled;
    }

    getMetadataTypeName(typeId: number): string {
        // Convert enum number to readable name
        const enumKeys = Object.keys(this.metadataType);
        const enumValues = Object.values(this.metadataType);
        const typeIndex = enumValues.indexOf(typeId);
        return typeIndex >= 0 ? enumKeys[typeIndex] : 'Unknown';
    }
}

